export default __webpack_public_path__ + "static/media/Kicad.28922ffb.png";